<template>
  <div class="wrap">
    <p
      class="MsoTitle"
      style="
        margin: 12pt 0cm 3pt;
        text-align: center;
        font-size: 16pt;
        font-family: 'Calibri Light', sans-serif;
        font-weight: bold;
      "
    >
      <a name="OLE_LINK24"></a>
    </p>
    <p
      class="MsoNormal"
      style="
        text-align: right;
        margin: 0cm;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun">日期：</span
      ><span lang="ZH-CN"> </span><span lang="EN-US">2021 </span
      ><span lang="ZH-CN" style="font-family: SimSun">年</span
      ><span lang="EN-US">5</span
      ><span lang="ZH-CN" style="font-family: SimSun">月</span
      ><span lang="EN-US">26 </span
      ><span lang="ZH-CN" style="font-family: SimSun">日</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
        text-indent: 10cm;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun"
        >德友惠服务端由深圳市德友惠信息技术有限公司（以下简称“我方”）开发，在您使用德友惠服务端时您需遵守本《德友惠软件服务协议》（以下简称“本协议”）相关规定。同时我方为高德地图黑卡商家服务商，基于高德地图委托为高德黑卡商家提供软件技术服务，若您为高德黑卡商家需要通过我方平台享受相关服务时，您也需遵守本协议。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun"
        >【阅读提示】您在点击同意本协议之前，应当认真阅读本协议。<b
          ><u
            >请您务必审慎阅读、充分理解各条款内容，特别是授权条款、免除或者限制责任的条款、该类条款将以粗体下划线标识，您应重点阅读。</u
          ></b
        >如您对协议内容有任何疑问，可向德友惠客服咨询，咨询电话</span
      ><span lang="EN-US">4006 016 466</span
      ><span lang="ZH-CN" style="font-family: SimSun">。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><u
          ><span lang="ZH-CN" style="font-family: SimSun"
            >如您不同意本协议的任意内容，请勿注册使用德友惠服务端的服务，并应立即停止注册程序。</span
          ><span lang="EN-US"><o:p></o:p></span></u
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><u><span lang="EN-US">&nbsp;</span></u></b
      >
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun"
        >【<b>签署行为</b>】<b
          ><u
            >如您点选确认“同意协议内容”并通过注册程序，即视为您已阅读并同意本协议，自愿接受本《德友惠软件服务协议》的所有内容的约束。请您在决定注册或使用服务前再次确认您已知悉并完全理解本服务协议的所有内容。</u
          ></b
        ></span
      ><b
        ><u
          ><span lang="EN-US"><o:p></o:p></span></u
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><u><span lang="EN-US">&nbsp;</span></u></b
      >
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: -21pt;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><span lang="EN-US"
          >一、<span
            style="
              font-variant-numeric: normal;
              font-variant-east-asian: normal;
              font-weight: normal;
              font-stretch: normal;
              font-size: 7pt;
              line-height: normal;
              font-family: 'Times New Roman';
            "
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ></b
      ><b
        ><span lang="ZH-CN" style="font-family: SimSun">账户注册与使用</span
        ><span lang="EN-US"><o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: 0cm;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">1.1 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >开通前，您需要完成德友惠服务端用户的注册或登录，如注册成功，您将获得平台用户账号，并可自行设置或修改账号密码。平台将通过用户账号及密码</span
      ><span lang="EN-US">/</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >手机验证码来识别用户的指令。您确认，使用您的用户账号及密码</span
      ><span lang="EN-US">/</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >手机验证码登陆后在平台的一切行为均代表您本人，用户账号操作所产生的电子信息记录均为用户行为的有效凭据，并由用户本人承担由此产生的法律责任</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">1.2</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >我方平台所提供的服务仅针对具有合格资质，能于线下提供与承诺相一致的商品、服务的企业用户开放。在您开通某项服务前您应按照我方相关要求上传相应的资质文件后，您应保证您提供的资料真实、准确、完整、合法、有效，如您的资料有所变动，您应及时更新注册资料。<b
          ><u
            >如因您所提供的注册资料不合法、不真实、不准确，从而导致的任何法律责任和不利后果均由您承担。</u
          ></b
        ></span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><u><span lang="EN-US">&nbsp;</span></u></b
      >
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">1.3 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >您签署接受本协议的行为并不意味着您即时获得相关账户开立资格，须经德友惠服务端用户资格审查通过方可实现账户开立。所以，在您成功取得德友惠服务端用户资格前，您和德友惠的选择是双向的，您有权选择是否加入并成为德友惠服务端用户，德友惠亦有权选择接受或拒绝您的开通申请。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">1.4 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >您应确保账号开通及日后使用过程中，始终保持相应的资质和服务能力，以确保您始终具有有效合格资质履行本协议项下的权利和义务，并具备在线下向终端消费者提供与承诺相一致的商品、服务能力。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">1.5</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >当需要请求您重新申请并依照系统提示要求确认或提供相应的信息、资质等电子或纸质书类文件时，若您希望继续接受德友惠服务端用户服务的，则请依照请求提供。<b
          ><u
            >如您拒绝提供相应信息、资质、文件时，德友惠服务端将视为您拒绝继续合作，则本协议自动终止，双方解除合作关系，您将不再继续享有本协议下的任何权利和义务。</u
          ></b
        ></span
      ><b
        ><u
          ><span lang="EN-US"><o:p></o:p></span></u
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><u><span lang="EN-US">&nbsp;</span></u></b
      >
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">1.6</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >当您所开通的账号可能关联用户身份信息、信用信息等，为更好地保护您的财产与信息安全，建议您妥善保护您的账号与密码，不要将您的账号与密码转让、售卖、赠与、借用、租用、泄露给第三方，如您因违反本条约定或账号遭受攻击、诈骗等而遭受损失，您应通过司法、行政等救济途径向侵权行为人追偿，平台不承担责任。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">1.7 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >您确保您将合理使用德友惠服务端，不利用德友惠服务端进行非法获利，不以任何形式转让或转移您所享有的德友惠服务端上的本人权益，不以任何方式将德友惠服务端借给他人使用。若德友惠服务端有合理理由怀疑您存在任何不当使用行为的，将取消您的德友惠服务端使用资格。您应对您不当使用行为及后果（包括损失）负责，您若给德友惠造成损失的，德友惠有权向您追偿。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">1.8 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >您保证您在获取和使用德友惠服务端过程中应遵守诚实信用原则，<b
          ><u
            >若德友惠合理怀疑您存在以下任一情形的，您可能面临开通申请被拒绝、已开通的被终止或中止、已绑定或获取的权益被全部</u
          ></b
        ></span
      ><b
        ><u><span lang="EN-US">/</span></u></b
      ><b
        ><u
          ><span lang="ZH-CN" style="font-family: SimSun"
            >部分取消或暂停使用。</span
          ></u
        ></b
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
        text-indent: 21pt;
      "
    >
      <span lang="EN-US">1.8.1</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >通过任何不正当手段或以违反诚实信用原则的方式德友惠服务端的，如恶意绕过正常开通流程；</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
        text-indent: 21pt;
      "
    >
      <span lang="EN-US">1.8.2</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >同一用户注册、持有、使用或控制多个德友惠服务端账号。其中，同一用户是指支付宝账户注册信息、网络操作日志、交易订单信息等与用户身份和行为相关的信息，其中任意一项或数项存在相同、相似，亦或通过特定标记批量信息进行分析，其数项被存在相同、相似的；</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
        text-indent: 21pt;
      "
    >
      <span lang="EN-US">1.8.3</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >在使用德友惠服务端时，存在虚假交易、提供虚假交易信息等扰乱交易秩序、违反交易规则的行为；</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
        text-indent: 21pt;
      "
    >
      <span lang="EN-US">1.8.4</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >其他违反诚实信用原则的行为。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: -21pt;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><span lang="EN-US"
          >二、<span
            style="
              font-variant-numeric: normal;
              font-variant-east-asian: normal;
              font-weight: normal;
              font-stretch: normal;
              font-size: 7pt;
              line-height: normal;
              font-family: 'Times New Roman';
            "
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ></b
      ><b
        ><span lang="ZH-CN" style="font-family: SimSun">权利说明与许可</span
        ><span lang="EN-US"><o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">2.1 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >德友惠对其提供的软件及相关产品或服务的全部内容，享有知识产权，受法律保护。未经我方书面许可，任何单位及个人不得以任何方式或理由对德友惠服务端的任何内容（包括但不限于产品、服务、信息、文字等）进行使用、复制、修改、抄录、传播或其他产品捆绑使用、销售、或以超级链路连接或传送、存储于信息检索系统或者其他任何商业目的的使用。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">2.2 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >为了完善平台服务内容，我方将不断努力开发新的服务，并为您不时提供应用程序的更新，应用程序新版本发布后，旧版本的应用程序可能无法使用，因此请您随时核对并下载最新版本的应用程序。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">2.3</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >我方产品或服务提供的内容是指我方通过德友惠服务端提供的任何内容，不论该内容是否由我方创造或被其他第三方许可使用。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">2.4</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >根据本条款的条款和条件，我方在此授予您一项个人的、不可转让的、不可转授权的、可撤销的、非独家的、非排他性的普通使用许可。您不得：</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun">（</span
      ><span lang="EN-US">1</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >）以任何方式许可、再许可、出售、转售、转让、分配、分发服务或应用程序，或以其他方式进行商业开发或提供给任何第三方；</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun">（</span
      ><span lang="EN-US">2</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >）修改平台服务功能或应用程序，或者据此创建衍生品；</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun">（</span
      ><span lang="EN-US">3</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >）反向工程或访问应用程序设计或构建竞争产品或服务、使用类似于平台服务或应用程序的设想或图形来设计或构建产品，或抄袭平台服务或应用程序的任何设想、特点、功能或图形。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun">（</span
      ><span lang="EN-US">4</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >）使用任何漫游器、抓取工具、网站搜索</span
      ><span lang="EN-US">/</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >检索应用程序或其他工具检索或索引我方产品或服务的任一部分，或出于任何未经授权的目的收集关于用户的信息；</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun">（</span
      ><span lang="EN-US">5</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >）进行其他未经我方明确许可的行为。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b><span lang="EN-US">2.5 </span></b
      ><b
        ><span lang="ZH-CN" style="font-family: SimSun"
          >如果出现您对本条款的违反行为，我方保留针对该违反行为采取法律所能提供的所有补救手段的权利。由于您的任何违法或违反本条款的使用行为而对我方或其他任何人造成任何损失的，我方有权要求您给予相应的赔偿，赔偿范围包括但不限于我方因此支付的罚款、赔偿金、诉讼费、律师费、公证费、调查证据费用等。</span
        ><span lang="EN-US"><o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b><span lang="EN-US">&nbsp;</span></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: -21pt;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><span lang="EN-US"
          >三、<span
            style="
              font-variant-numeric: normal;
              font-variant-east-asian: normal;
              font-weight: normal;
              font-stretch: normal;
              font-size: 7pt;
              line-height: normal;
              font-family: 'Times New Roman';
            "
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ></b
      ><b
        ><span lang="ZH-CN" style="font-family: SimSun">守法承诺</span
        ><span lang="EN-US"><o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">3.1 </span
      ><b
        ><u
          ><span lang="ZH-CN" style="font-family: SimSun"
            >您在使用德友惠服务端构建企业服务内容信息时尽守法义务，保证您所提供的相关服务和商品不会违反《消费者权益保护法》、《产品质量法》等法律、法规、规章的规定，不会损害消费者合法权益。</span
          ><span lang="EN-US"><o:p></o:p></span></u
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">3.2 </span
      ><b
        ><u
          ><span lang="ZH-CN" style="font-family: SimSun"
            >您所提供的相关服务和商品不会侵犯任何第三方权利。</span
          ><span lang="EN-US"><o:p></o:p></span></u
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: -21pt;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><span lang="EN-US"
          >四、<span
            style="
              font-variant-numeric: normal;
              font-variant-east-asian: normal;
              font-weight: normal;
              font-stretch: normal;
              font-size: 7pt;
              line-height: normal;
              font-family: 'Times New Roman';
            "
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ></b
      ><b
        ><span lang="ZH-CN" style="font-family: SimSun">注册信息保护承诺</span
        ><span lang="EN-US"><o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">4.1 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >在您使用我方产品或服务的过程中，我们会基于您需求的服务，收集和使用您的个人信息，包括您的身份信息、经营资质信息，请您认真阅读《隐私权政策》并在确认同意后使用相关服务。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      align="left"
      style="margin: 0cm; font-size: 10.5pt; font-family: Calibri, sans-serif"
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      align="left"
      style="margin: 0cm; font-size: 10.5pt; font-family: Calibri, sans-serif"
    >
      <span lang="EN-US">4.2 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >德友惠服务端将对您所提交的注册信息予以保护，不会将其披露给任何非关联的第三方，除非：</span
      ><span lang="ZH-CN"></span><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      align="left"
      style="margin: 0cm; font-size: 10.5pt; font-family: Calibri, sans-serif"
    >
      <span lang="ZH-CN" style="font-family: SimSun">（</span
      ><span lang="EN-US">1</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >）相关法律法规或国家机关要求；</span
      ><span lang="ZH-CN"></span><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      align="left"
      style="margin: 0cm; font-size: 10.5pt; font-family: Calibri, sans-serif"
    >
      <span lang="ZH-CN" style="font-family: SimSun">（</span
      ><span lang="EN-US">2</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >）德友惠服务端发生相关合并、分立、收购或资产转移；或</span
      ><span lang="ZH-CN"></span><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun">（</span
      ><span lang="EN-US">3</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >）为提供相关服务所必须的</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: -21pt;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><span lang="EN-US"
          >五、<span
            style="
              font-variant-numeric: normal;
              font-variant-east-asian: normal;
              font-weight: normal;
              font-stretch: normal;
              font-size: 7pt;
              line-height: normal;
              font-family: 'Times New Roman';
            "
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ></b
      ><b
        ><span lang="ZH-CN" style="font-family: SimSun">本协议的终止</span
        ><span lang="EN-US"><o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: 0cm;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">5.1 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >您应理解德友惠客户端服务有根据实际情况调整有效期的权利，如您在德友惠客户端有效期届满或高德黑卡会员资格<b
          ><u>到期且您未重新开通的，相应服务将予以终止，本协议失效。</u></b
        ></span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">5.2 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >您应理解按本协议及相关规则使用德友惠客户端，并遵守相关限制以及按本协议约定履行义务是您使用德友惠客户端的前提，<b
          ><u
            >如您违反本协议的相关约定，德友惠会视您的实际违约情况选择中止、终止或解除本协议。</u
          ></b
        ></span
      ><b
        ><u
          ><span lang="EN-US"><o:p></o:p></span></u
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">5.3 </span
      ><b
        ><u
          ><span lang="ZH-CN" style="font-family: SimSun"
            >因您为违反本协议或任何相关法律的行为，欺诈或滥用德友惠客户端的行为，或损害德友惠利益或伤害其他用户的行为而导致的终止。</span
          ></u
        ></b
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">5.4 </span
      ><b
        ><u
          ><span lang="ZH-CN" style="font-family: SimSun"
            >本协议的终止并不影响终止前您与德友惠基于本协议产生的权利义务。因您的原因导致德友惠遭受第三方索赔、行政部门处罚等，您应当赔偿德友惠因此产生的损失及（或）发生的费用，包括合理的律师费用、调查取证费用等。</span
          ></u
        ></b
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: -21pt;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><span lang="EN-US"
          >六、<span
            style="
              font-variant-numeric: normal;
              font-variant-east-asian: normal;
              font-weight: normal;
              font-stretch: normal;
              font-size: 7pt;
              line-height: normal;
              font-family: 'Times New Roman';
            "
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ></b
      ><b
        ><span lang="ZH-CN" style="font-family: SimSun">无担保和责任限制</span
        ><span lang="EN-US"><o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: 0cm;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
        text-indent: 21pt;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun"
        >您理解德友惠将尽最大努力确保本服务及其所涉及的技术及信息安全、有效、准确、可靠，但受限于现有技术及德友惠有限的服务能力，<b
          ><u
            >对于下述原因导致的履行障碍、瑕疵、延后或内容变更等情形，导致您直接或间接损失，您理解德友惠无法承担责任：</u
          ></b
        ></span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
        text-indent: 21pt;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">6.1 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >因自然灾害、罢工、暴乱、战争、恐怖袭击、政府行为、司法行政命令等不可抗力因素；</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">6.2 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >因电信部门技术调整或故陣、通讯网络故障等公共服务因素；</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">6.3</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >用户自身设备的软件、系统、硬件和通信</span
      ><span lang="ZH-CN"> </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >线路出现故陣，或用户通过非本协议项下约定的方式使用本服务的；</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">6.4</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >德友惠已善意管理，但出现紧急设备</span
      ><span lang="EN-US">/</span
      ><span lang="ZH-CN" style="font-family: SimSun">系统的故障</span
      ><span lang="EN-US">/</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >维护、网络信息与数据安全等情况。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: -21pt;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><span lang="EN-US"
          >七、<span
            style="
              font-variant-numeric: normal;
              font-variant-east-asian: normal;
              font-weight: normal;
              font-stretch: normal;
              font-size: 7pt;
              line-height: normal;
              font-family: 'Times New Roman';
            "
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ></b
      ><b
        ><span lang="ZH-CN" style="font-family: SimSun">第三方服务</span
        ><span lang="EN-US"><o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b><span lang="EN-US">&nbsp;</span></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">7.1 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >我方作为高德黑卡商家服务商为高德黑卡商家提供相应的技术支持，以便高德黑卡商家能够通过实现高德地图门店认领、门店信息管理、商品发布等功能目的。高德黑卡商家通过德友惠服务端使用相应服务</span
      ><span lang="EN-US">/</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >功能时受到本协议以及与黑卡商家服务规则有关的约束。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">7.2</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >若您想开通高德地图黑卡商家您需保证您为一家合法成立并有效存续的经营主体，能够独立承担法律责任；同时应当按相应要求提供有效的身份证明资料及经营能力证明文件（包括但不限于营业执照、许可证及其他相关法律法规规定应当具备的许可或备案文件）并缴纳一定费用后方可开通高德黑卡商家服务。且</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun"
        >您理解德友惠服务端的功能实现及您的高德地图黑卡商家权益的实现需要部分第三方服务的采购接入。您向德友惠服务端指定账户支付的费用既已包含黑卡商家套餐服务费及其他第三方服务费，相关费用嗣后由德友惠服务端统一支付至高德地图软件运营方及其他第三方服务提供方。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">7.3</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >对于您所提供的证明文件或上传的信息，我方有权进行审核和登记，若我方发现您上传的资料或信息存在虚假、错误或其他问题时，我方有权要求您予以补正，若您未予以补正的，我方有权拒绝您的相关服务要求，并有权对您采取必要措施（包括但不限于屏蔽、下线、删除甲方商品或服务等）。但前述审核不应视为我方对您所提供证明文件的合法性、有效性作了任何明示或暗示的担保，您仍对您自身行为承担完全独立的责任。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">7.4</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >您保证您在开通黑卡商家后所发布服务或商品信息（包括但不限于价格、服务内容、使用时间等），符合国家法律、法规、规章的规定并能够按照其所发布服务或商品真实内容向用户提供相应的服务。我方有权对您的各项服务的情况进行监督和检查，若我方发现您在服务过程中，存在违法违规或其他损害他人合法利益的行为的，我方有权对您采取必要措施，以制止相应的违法行为，因此产生的任何损失，由您自行承担。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><span lang="EN-US">&nbsp;<o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoListParagraph"
      style="
        margin: 0cm 0cm 0cm 21pt;
        text-align: justify;
        text-indent: -21pt;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <b
        ><span lang="EN-US"
          >八、<span
            style="
              font-variant-numeric: normal;
              font-variant-east-asian: normal;
              font-weight: normal;
              font-stretch: normal;
              font-size: 7pt;
              line-height: normal;
              font-family: 'Times New Roman';
            "
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ></b
      ><b
        ><span lang="ZH-CN" style="font-family: SimSun">其他</span
        ><span lang="EN-US"><o:p></o:p></span
      ></b>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">8.1</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >由于互联网高速发展，您与德友惠签署的本协议列明的条款并不能完整罗列和涵盖您与德友惠之间的所有权利与义务，现有的约定也不能完全保证符合未来发展的需求。德友惠可根据国家法律法规变化及维护服务秩序、保护用户权益的需要，不时修改本协议，变更后的协议将通过程序通知提示方式通知您，并依法生效。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">8.2 </span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >德友惠可能根据业务调整而变更向您提供服务的主体，变更后的主体与您共同履行本协议并向您提供本协议中德友惠承诺的服务内容，基于以上变更并不常见而且并不会影响您本协议项下享受权益的情形下，德友惠对此将不再另行通知。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">8.3</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >德友惠未能坚持或未能强制要求您严格遵守本协议不构成对任何权利的放弃。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">8.4</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >如您对德友惠及德友惠服务端有任何意见建议，请拨打文首德友惠客服电话。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">8.5</span
      ><span lang="ZH-CN" style="font-family: SimSun"
        >本条款的执行、解释及争议的解决均适用中华人民共和国法律，且不考虑任何冲突法。您和我方就产品或服务使用、本条款内容或其执行发生任何争议的，双方应友好协商解决；如双方无法协商解决争议时，双方同意应将争议提交至被告住所地人民法院裁决。</span
      ><span lang="EN-US"><o:p></o:p></span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
        text-indent: 21pt;
      "
    >
      <span lang="ZH-CN" style="font-family: SimSun; font-weight: 700"
        >您已充分阅读并理解本《德友惠软件服务协议》，在此基础上同意本协议下的相关权利义务约定并自愿签署本协议生效并遵照执行。</span
      >
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
    <p
      class="MsoNormal"
      style="
        margin: 0cm;
        text-align: justify;
        font-size: 10.5pt;
        font-family: Calibri, sans-serif;
      "
    >
      <span lang="EN-US">&nbsp;</span>
    </p>
  </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class PolicyProtocol extends Vue {}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 20px 15px;
}
</style>
